<style scoped>
   .section-block {
      margin-bottom: 1.5rem;
   }

   .section-header {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 1rem;
      padding-bottom: 0.75rem;
      border-bottom: 1px solid #e5e7eb;
   }

   .section-title {
      font-size: 20px;
      font-weight: 600;
      margin: 0;
      color: #111;
   }

   .section-sub {
      font-size: 14px;
      color: #6b7280;
      margin: 0;
   }
</style>
<template>
    <div>
        <app-overlay-loader v-if="preloader" />
        <form ref="form" data-url="/crud" :class="{ 'loading-opacity': preloader }">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="col-md-6">
                    <InputText v-model="inputs.cud_master_po" :is_view="is_view" label="Master PO" />  
                </div>
                <br>
                <div class="section-block">
                    <div class="section-header">
                        <div>
                            <h3 class="section-title">Customer & Shipment Route</h3>
                            <p class="section-sub">Select customer and configure origin, destination and addresses</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <AddressRequired v-model="inputs.cud_selectedOption" :read="is_view" :num="4" />
                        </div>

                        <div class="col-md-6">
                            <SelectCustom v-model="inputs.cud_ship" :is_view="is_view" :list="from_to_list" label="Ship from/to" :required="!toggle_validation" divGridClass="col-sm-12" />
                        </div>

                        <div class="col-md-6">
                            <SelectHttp v-model="inputs.cud_customer" @input="validateCustomer" :is_view="is_view || isFromCost" label="Customer" :required="true" url="/companies_customer/serverside/selectable-name" listValueField="Title" divGridClass="col-sm-12" /> 
                            <DescriptionAddress  v-model="inputs.cud_descriptionCustomer" :read="is_view" />
                        </div>

                        <div class="col-md-6">  
                            <SelectCustom v-model="inputs.cud_selected_ship_address_1" :is_view="is_view" :list="ship_address_list" label="Ship Address (A, Required)" :required="!toggle_validation" divGridClass="col-sm-12" />
                            <DescriptionAddress v-model="inputs.cud_descriptionShipAddress1" :read="is_view" />
                        </div>

                        <div class="col-md-6" v-if="inputs.cud_selectedOption >= 2">
                            <SelectCustom v-model="inputs.cud_selected_ship_address_2" :is_view="is_view" :list="ship_address_list" label="Ship Address (B, Optional)" divGridClass="col-sm-12" />
                            <DescriptionAddress v-model="inputs.cud_descriptionShipAddress2" :read="is_view" />
                        </div>

                        <div class="col-md-6" v-if="inputs.cud_selectedOption >= 3">
                            <SelectCustom  v-model="inputs.cud_selected_ship_address_3" :is_view="is_view" :list="ship_address_list" label="Ship Address (C, Optional)" divGridClass="col-sm-12" />
                            <DescriptionAddress v-model="inputs.cud_descriptionShipAddress3" :read="is_view" />
                        </div> 

                        <div class="col-md-6" v-if="inputs.cud_selectedOption >= 4">  
                            <SelectCustom  v-model="inputs.cud_selected_ship_address_4" :is_view="is_view" :list="ship_address_list" label="Ship Address (D, Optional)" divGridClass="col-sm-12" />
                            <DescriptionAddress v-model="inputs.cud_descriptionShipAddress4" :read="is_view" />
                        </div>
                     </div>
                     <div class="row">
                        <div class="col-md-6">
                            <SelectCustom v-model="inputs.cud_finalDestination" :is_view="is_view" :list="ship_final_destination_list" label="Ship final dest" divGridClass="col-sm-12" />   
                        </div>

                        <div class="col-md-6">
                            <SelectCustom v-model="inputs.cud_finalDest" :is_view="is_view" :list="ship_address_list" label="Final destination" divGridClass="col-sm-12" />   
                            <DescriptionAddress v-model="inputs.cud_descriptionFinalDestination" :read="is_view" />
                        </div>  
                    </div>
                </div>
                <div class="section-block">
                    <div class="section-header">
                        <div>
                            <h3 class="section-title">Shipment Dates & Details</h3>
                            <p class="section-sub">Define shipment period and additional information</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <InputDate v-model="inputs.cud_start_date" :is_view="is_view" label="Start date" />
                        </div>
                        <div class="col-md-6">
                            <TextArea v-model="inputs.cud_additional_ship" label="Additional shipment detail" :is_view="is_view" divGridClass="col-sm-12"/>
                        </div>
                        <div class="col-md-6">
                            <InputDate v-model="inputs.cud_end_date" :is_view="is_view" label="End date" />
                        </div>  
                    </div>
                </div>   

                <div class="section-block">
                    <div class="section-header">
                        <div>
                            <h3 class="section-title">Commercial Terms</h3>
                            <p class="section-sub">Payment, incoterms, label and pricing </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <SelectCustom v-model="inputs.cud_pay_term" :is_view="is_view" :list="payment_term_list" :required="!toggle_validation" label="Payment term" divGridClass="col-sm-12" />   
                        </div>
                        
                        <div class="col-md-6">
                            <SelectCustom v-model="inputs.cud_label" :is_view="is_view" :required="!toggle_validation" :list="labelList" label="Label" divGridClass="col-sm-12" />   
                        </div>

                        <div class="col-md-6">
                            <SelectHttp v-model="inputs.cud_broker" :is_view="is_view" label="Broker" url="/broker/serverside/selectable-name" listValueField="value" divGridClass="col-sm-12" /> 
                        </div>

                        <div class="col-md-6">
                            <TextArea v-model="inputs.label_description" label="Label description" :is_view="is_view" divGridClass="col-sm-12" />
                        </div>

                        <div class="col-md-6">
                            <InputNumber v-model="inputs.cud_commision" :is_view="is_view" label="Comission" divGridClass="col-md-12"/>
                        </div>
                    </div>

                    <!-- options A -->
                    <div class="row">
                        <div class="col-md-6">
                            <SelectCustom v-model="inputs.cud_incoterm" :is_view="is_view || isFromCost" :list="incotermList" :required="!toggle_validation" label="Incoterm A" divGridClass="col-sm-12" />   
                        </div>

                        <div class="col-md-6" v-if="inputs.cud_selectedOption >= 2">
                            <SelectCustom v-model="inputs.cud_incoterm_2" :is_view="is_view" :list="incotermList" label="Incoterm B" divGridClass="col-sm-12" />   
                        </div>

                        <div class="col-md-6" v-if="inputs.cud_selectedOption >= 3">
                            <SelectCustom v-model="inputs.cud_incoterm_3" :is_view="is_view" :list="incotermList" label="Incoterm C" divGridClass="col-sm-12" />   
                        </div>

                        <div class="col-md-6" v-if="inputs.cud_selectedOption >= 4">
                            <SelectCustom  v-model="inputs.cud_incoterm_4" :is_view="is_view" :list="incotermList" label="Incoterm D" divGridClass="col-sm-12" />   
                        </div>
                    </div>
                </div>

                <div class="section-block">
                    <div class="section-header">
                        <div>
                            <h3 class="section-title">Conditions</h3>
                            <p class="section-sub">Manage and configure your general conditions</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <TextArea v-model="inputs.cud_customer_cond" label="Customer conditions" :is_view="is_view" divGridClass="col-sm-12"/>
                        </div> 

                        <div class="col-md-6">
                            <SelectHttp v-model="inputs.cud_customer_condition" :is_view="is_view" label="Contract conditions" url="/contract_condition/serverside/selectable-name" listValueField="value" divGridClass="col-sm-12" />
                        </div>
                    </div>
                </div>
            </div>        

            <div class="row">
                <div class="col-md-3">
                    <button type="button" class="btn btn-primary mr-2 w-100" 
                        @click="redirectToRevision">
                        {{ $t('continue') }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';
import SelectCustom from '../components/SelectCustom.vue';
import SelectHttp from '../components/SelectHttp.vue';
import InputNumber from '../components/InputNumber.vue';
import InputText from "../components/InputText.vue";
import TextArea from "../components/TextArea.vue";
import InputDate from '../components/InputDate.vue';
import AddressRequired from '../components/AddressRequired.vue';
import DescriptionAddress from '../components/DescriptionAddress.vue';
import {concatCompany, contactAddress, findObject, validateForm} from "../mixins/functions.js";
import {get_data_customTable, get_ship_address_customer, get_data_customer} from '../mixins/api.js';

export default {
    name: "products-detail",
    mixins: [FormMixin],
    components: {
        AddressRequired, InputText, SelectCustom, SelectHttp, InputDate, TextArea, InputNumber, DescriptionAddress,
    },
    data() {
        return {
            contractId : null, 
            preloader : false,
            from_to_list : [],
            ship_final_destination_list : [],
            payment_term_list : [],
            ship_address_list : [],
            incotermList : [],
            labelList : [],
            isLoading : false,
            toggle_validation : false,
            isFromCost : false,
            inputs: {
                cud_selectedOption :            1,
                cud_master_po :                 null,
                cud_ship :                      null,
                cud_customer :                  { id: null },
                cud_descriptionCustomer :       null,
                cud_selected_ship_address_1 :   null,
                cud_descriptionShipAddress1 :   null,
                cud_selected_ship_address_2 :   null,
                cud_descriptionShipAddress2 :   null,
                cud_selected_ship_address_3 :   null,
                cud_descriptionShipAddress3 :   null,
                cud_selected_ship_address_4 :   null,
                cud_descriptionShipAddress4 :   null,
                cud_finalDestination        :   null,
                cud_finalDest   :               null,
                cud_descriptionFinalDestination : null,
                cud_start_date :                null,
                cud_additional_ship :           null,
                cud_end_date :                  null,
                cud_pay_term :                  null,
                cud_incoterm :                  null,
                cud_incoterm_2 :                null,
                cud_incoterm_3 :                null,
                cud_incoterm_4 :                null,
                cud_customer_cond :             null,
                cud_label :                     { id :null},
                cud_broker :                    { id:null },
                cud_commision :                 null, 
                cud_customer_condition :        { id:null },
                label_description : null,
            },   
        }
    },
    computed: {
        is_view() {
            const is_view = localStorage.getItem('process_view_contract');
            if(is_view) return true;
            return false;
        },
    },
    methods: {
        async loadCustomerDetails(id) {
            if (id) {
                const respuesta = await get_data_customer(id);
                this.ship_address_list = await get_ship_address_customer(respuesta.cud_customer.id); 
                localStorage.setItem('DataCustomerDetail', JSON.stringify(respuesta));
            }
        },

        async loadData() {
            this.preloader = true;
            this.isLoading = true;
            await Promise.all([
                        this.fetchData('ship_from_to'),
                        this.fetchData('payment_term'),
                        this.fetchData('incoterm'),
                        this.fetchData('label'),
            ]);
            this.ship_final_destination_list = [{id : 1, value : 'Ship To'}];
            const savedInputs = localStorage.getItem('DataCustomerDetail') ? JSON.parse(localStorage.getItem('DataCustomerDetail')) : null;
            if (savedInputs) {
                await this.set_inputs(savedInputs);
            }
            this.isLoading = false;
            this.preloader = false;
        },

        async fetchData(customTable) {
            const data = await get_data_customTable(customTable);
            if (customTable == 'ship_from_to') this.from_to_list = data; 
            else if (customTable == 'incoterm') this.incotermList = data; 
            else if (customTable == 'payment_term') this.payment_term_list = data;
            else if (customTable == 'label') this.labelList = data;
        },

        async set_inputs(savedInputs){
            if (savedInputs.cud_customer) this.validateCustomer(savedInputs.cud_customer);
            Object.keys(savedInputs).forEach(value => {
                this.inputs[value] = savedInputs[value];
            })
        },

        async fetchCustomerDetails(customerId) { 
			this.inputs.cud_descriptionCustomer = concatCompany(this.inputs.cud_customer);  
            const idCustomer = customerId ? customerId : this.inputs.cud_customer.id;
            if (idCustomer) {
                this.ship_address_list = await get_ship_address_customer(idCustomer); 		 
            }
            const savedInputs = localStorage.getItem('DataCustomerDetail') ? JSON.parse(localStorage.getItem('DataCustomerDetail')) : null;
			await this.set_inputs(savedInputs);
		},

        async redirectToRevision() {
            const validations = {
                cud_customer: "Customer required",
            };
            if (!this.toggle_validation) {
                validations.cud_ship = "Ship from/to required";
                validations.cud_selected_ship_address_1 = "Ship address required";
                validations.cud_pay_term = "Pay term required";
                validations.cud_incoterm = "Incoterm required";
                validations.cud_label = "Label required";
            }
            
            if (!validateForm(this.inputs, validations, this.$toastr)) {
                return;
            }

            if (this.inputs.cud_customer.Title === 'Customer to be confirmed') {
                await this.updateContractStatus();
            }

            this.redirected = true;
            this.$router.push({
                name: 'documents',
                query: { 'tab': 'documents' },
                params: { id: this.contractId }
            });
        },

        async updateContractStatus() {
            // Obtener los status
            const statusDb = await get_data_customTable('status');
            const pendingStatus = statusDb.find( status => status.value === 'Pending');
            
            const dataContract = JSON.parse(localStorage.getItem('DataContractDetail'));
            if (pendingStatus) {
                dataContract.status = pendingStatus;
                localStorage.setItem('DataContractDetail', JSON.stringify(dataContract));
            } 
        },

        validateCustomer(customer){
			if(customer?.Title === 'Customer to be confirmed'){
				this.toggle_validation = true;
				return;
			}
			this.toggle_validation = false;
		},

        updateInputs(newVal){
            for (let i = newVal + 1; i <= 4; i++) {
                this.inputs[`cud_selected_ship_address_${i}`] = null;
                this.inputs[`cud_incoterm_${i}`] = null;
            }
        },
    },
    
    watch : {
        'inputs.cud_selectedOption'(newValue, oldValue){
            this.updateInputs(newValue);
        },
        'inputs.cud_customer.id'(newValue, oldValue) {   
            this.fetchCustomerDetails(newValue);
        },
        'inputs.cud_selected_ship_address_1': {
            handler(newVal, oldVal) { 
                if (newVal) {
                    this.inputs.cud_selected_ship_address_1 = newVal;
                    this.inputs.cud_descriptionShipAddress1 = contactAddress(newVal);
                }else{
                    this.inputs.cud_selected_ship_address_1 = null;
                    this.inputs.cud_descriptionShipAddress1 = null;
                }
            },
            immediate: true // Para que se ejecute de inmediato en caso ya haya un valor
        },
        'inputs.cud_selected_ship_address_2': {
            handler(newVal, oldVal) { 
                if (newVal) {
                    this.inputs.cud_selected_ship_address_2 = newVal;
                    this.inputs.cud_descriptionShipAddress2 = contactAddress(newVal);
                }else {
                    this.inputs.cud_selected_ship_address_2 = null;
                    this.inputs.cud_descriptionShipAddress2 = null;
                }
            },
            immediate: true // Para que se ejecute de inmediato en caso ya haya un valor
        },
        'inputs.cud_selected_ship_address_3': {
            handler(newVal, oldVal) { 
                if (newVal) {
                    this.inputs.cud_selected_ship_address_3 = newVal
                    this.inputs.cud_descriptionShipAddress3 = contactAddress(newVal);
                }else {
                    this.inputs.cud_selected_ship_address_3 = null;
                    this.inputs.cud_descriptionShipAddress3 = null;
                }
            },
            immediate: true // Para que se ejecute de inmediato en caso ya haya un valor
        },
        'inputs.cud_selected_ship_address_4': {
            handler(newVal, oldVal) { 
                if (newVal) {
                    this.inputs.cud_selected_ship_address_4 = newVal;
                    this.inputs.cud_descriptionShipAddress4 = contactAddress(newVal);
                }else {
                    this.inputs.cud_selected_ship_address_4 = null;
                    this.inputs.cud_descriptionShipAddress4 = null;
                }
            },
            immediate: true // Para que se ejecute de inmediato en caso ya haya un valor
        },
        "inputs.cud_finalDest": {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.inputs.cud_finalDest = newVal
                    this.inputs.cud_descriptionFinalDestination = contactAddress(newVal);
                } else {
                    this.inputs.cud_finalDest = null
                    this.inputs.cud_descriptionFinalDestination = null;
                }
            },
            immediate: true, // Para que se ejecute de inmediato en caso ya haya un valor
        },
        inputs : {
            deep : true,
            handler(newVal){ // detecta los cambios de los inputs      
                localStorage.setItem('DataCustomerDetail', JSON.stringify(newVal));            
            }
        }
    }, 
    async mounted() {   
        this.contractId = this.$route.params.id;
        if (!this.contractId && !localStorage.getItem('DataCustomerDetail')) {
            this.contractId = JSON.parse(localStorage.getItem('DataContractDetail')).cd_contract_id;
        }
        if (this.contractId) {
            await this.loadCustomerDetails(this.contractId); 
        }
        if (typeof localStorage.getItem('is_from_cost') !== 'undefined' && localStorage.getItem('is_from_cost')) {
            this.isFromCost = true;
        }
        this.loadData();
    },
}
</script>
